import React from 'react'

import GenericErrorPage from '@pages/errors/GenericErrorPage'
import MyBooksPage from '@pages/home/MyBooksPage'
import DashboardError from '@pages/home/dashboard/DashboardError'
import dashboardLoader from '@pages/home/loaders/dashboard.loader'
import messagesLoader from '@pages/home/loaders/messages.loader'
import myBooksLoader from '@pages/home/loaders/myBooks.loader'

import ActivityPage from './ActivityPage'
import CollectionPage from './CollectionPage'
import DeletedScoresPage from './DeletedScoresPage'
import FavoriteScoresPage from './FavoriteScoresPage'
import MessagesPage from './MessagesPage'
import MyScoresPage from './MyScoresPage'
import PurchasedScoresPage from './PurchasedScoresPage'
import RedeemedContentPage from './RedeemedContentPage'
import SharedScoresPage from './SharedScoresPage'
import TemplateCopiesPage from './TemplateCopiesPage'
import homeActionRoutes from './actions/routes'
import DashboardPage from './dashboard/DashboardPage'
import collectionLoader from './loaders/collection.loader'
import deletedScoresLoader from './loaders/deletedScores.loader'
import favoritesLoader from './loaders/favorites.loader'
import myScoresLoader, { myScoresRevalidator } from './loaders/myScores.loader'
import purchasedScoresLoader from './loaders/purchasedScores.loader'
import sharedScoresLoader from './loaders/sharedScores.loader'
import templateLoader from './loaders/template.loader'

import type { RouteObject } from 'react-router-dom'

const actionRoutes: RouteObject[] = [
  {
    index: true,
    element: <MyScoresPage />,
    errorElement: <GenericErrorPage titleKey="messages.scoresLoadingFailed" />,
    loader: myScoresLoader,
    shouldRevalidate: myScoresRevalidator,
  },
  {
    path: 'myScores',
    element: <MyScoresPage />,
    errorElement: <GenericErrorPage titleKey="messages.scoresLoadingFailed" />,
    loader: myScoresLoader,
    shouldRevalidate: myScoresRevalidator,
  },
  {
    path: 'myBooks',
    element: <MyBooksPage />,
    loader: myBooksLoader,
  },
  {
    path: 'purchasedScores',
    element: <PurchasedScoresPage />,
    errorElement: <GenericErrorPage titleKey="messages.scoresLoadingFailed" />,
    loader: purchasedScoresLoader,
  },
  {
    path: 'favorites',
    element: <FavoriteScoresPage />,
    errorElement: <GenericErrorPage titleKey="messages.scoresLoadingFailed" />,
    loader: favoritesLoader,
  },
  {
    path: 'sharedWithMe',
    element: <SharedScoresPage />,
    errorElement: <GenericErrorPage titleKey="messages.scoresLoadingFailed" />,
    loader: sharedScoresLoader,
  },
  {
    path: 'deletedScores',
    element: <DeletedScoresPage />,
    errorElement: <GenericErrorPage titleKey="messages.scoresLoadingFailed" />,
    loader: deletedScoresLoader,
  },
  {
    path: 'collection/:collectionId',
    element: <CollectionPage />,
    loader: collectionLoader,
  },
  {
    id: 'templateCopies',
    path: 'template/:templateScoreId',
    element: <TemplateCopiesPage />,
    loader: templateLoader,
  },
  {
    path: 'redeemedContent/:id',
    element: <RedeemedContentPage />,
  },
  {
    path: 'dashboard',
    element: <DashboardPage />,
    errorElement: <DashboardError />,
    loader: dashboardLoader,
  },
  {
    path: 'activity',
    element: <ActivityPage />,
    errorElement: <GenericErrorPage titleKey="messages.activityLoadingFailed" />,
  },
  {
    path: 'messages',
    element: <MessagesPage />,
    errorElement: <GenericErrorPage titleKey="messages.newsLoadingFailed" />,
    loader: messagesLoader,
  },
  ...homeActionRoutes,
]
export default actionRoutes
